import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getDateRangeWithSessionFallback } from '#component/general/date-range/helper';
import {
  FETCH_PROJECTS_LOGS,
  PROJECTS_LOGS_CLEAR,
  PROJECTS_LOGS_CHANGE_ORDER,
  FETCH_PROJECTS_LOGS_FAILED,
  FETCH_PROJECTS_LOGS_STARTED,
  PROJECTS_LOGS_PAGINATED_CHANGE_PAGE
} from '#action/types';
import { getRequestOptions, getDateRange, getURLParameter, setIdsParam } from '#helper';

let abortController = new AbortController();

export const fetchProjectLogs = () => async (dispatch, getState) => {
  try {
    abortController.abort();
    dispatch({
      type: FETCH_PROJECTS_LOGS_STARTED
    });

    const filter = getState().listFilter;
    const sourcePath = 'project-log';
    const logFilter = filter[sourcePath];
    const { page, itemsPerPage, order } = getState().projectsLogs;
    const urlPage = getURLParameter('page');
    const offset = (Number(urlPage || page) - 1) * itemsPerPage;
    const searchParams = new URLSearchParams({
      order,
      offset,
      limit: 50
    });
    const projectValue = logFilter?.project?.value;
    const userValue = logFilter?.user?.value;
    const { start: dateRangeStart, end: dateRangeEnd } = getDateRangeWithSessionFallback(
      logFilter?.start?.value,
      logFilter?.end?.value
    );
    const eventValue = logFilter?.event?.value;
    setIdsParam(searchParams, 'project', projectValue);
    setIdsParam(searchParams, 'user', userValue);
    setIdsParam(searchParams, 'event', eventValue);

    if (dateRangeStart && dateRangeEnd) {
      const range = getDateRange(dateRangeStart, dateRangeEnd);
      searchParams.set('start', range.start);
      searchParams.set('end', range.end);
    }

    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const url = webPortalApi.buildApiUrl(`project/log?${searchParams.toString()}`);
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      const response = await res.json();
      dispatch({
        type: FETCH_PROJECTS_LOGS_FAILED,
        error: response
      });
      return dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
    }

    const { logs = [], last } = await res.json();

    return dispatch({
      type: FETCH_PROJECTS_LOGS,
      totalCount: last,
      payload: logs
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }
    return dispatch({
      type: FETCH_PROJECTS_LOGS_FAILED,
      error: e
    });
  }
};

export const changeOrder = (newOrder, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: PROJECTS_LOGS_CHANGE_ORDER,
    payload: newOrder
  });

  if (refetch) {
    dispatch(fetchProjectLogs());
  }
};

export const changePage = (newPage, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: PROJECTS_LOGS_PAGINATED_CHANGE_PAGE,
    payload: newPage
  });

  if (refetch) {
    dispatch(fetchProjectLogs());
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: PROJECTS_LOGS_CLEAR
  });
};
